var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowDownBold(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 7,
    viewBox: "0 0 13 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.802922 0.46967C1.09582 0.176777 1.57069 0.176777 1.86358 0.46967L6.33325 4.93934L10.8029 0.46967C11.0958 0.176777 11.5707 0.176777 11.8636 0.46967C12.1565 0.762563 12.1565 1.23744 11.8636 1.53033L6.86358 6.53033C6.57069 6.82322 6.09582 6.82322 5.80292 6.53033L0.802922 1.53033C0.510029 1.23744 0.510029 0.762563 0.802922 0.46967Z",
    fill: "#4267EB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownBold);
export default __webpack_public_path__ + "static/media/arrow-down-bold.08a673186e705382accb0f4693146e1b.svg";
export { ForwardRef as ReactComponent };